import React from 'react';
import AdminSidebar from './AdminSidebar';

export default function AdminContainer({ children }) {
    return (
        <div className="main-page-layout">
            <AdminSidebar />
            <div className="dashboard-content">
                {children}
            </div>
        </div>
    );
}
